module.exports = __webpack_public_path__ + "SCTProfessional/static/dist/img/Logo_SCT_Outil_Pro_Big.56729bbe.png";